export interface StreetAndNumberParts {
    /** Tokens without digits, joined in original order — used as the street name query */
    streetName: string
    /** Tokens containing at least one digit, joined in original order (handles `12`, `12a`, `3-5`, `4/1`) */
    houseNumber: string
}

/**
 * Splits a combined "street and number" input into a street-name query and the
 * house-number part: every whitespace-separated token containing a digit counts
 * as house number, the rest is the street name.
 */
export function splitStreetAndNumber(input: string): StreetAndNumberParts {
    const tokens = input.trim().split(/\s+/).filter(Boolean)
    const streetTokens: string[] = []
    const houseNumberTokens: string[] = []

    for (const token of tokens) {
        if (/\d/.test(token)) {
            houseNumberTokens.push(token)
        } else {
            streetTokens.push(token)
        }
    }

    return {
        streetName: streetTokens.join(' '),
        houseNumber: houseNumberTokens.join(' ')
    }
}

/** Combines a selected street name with the house number the user already typed. */
export function combineStreetAndNumber(streetName: string, houseNumber: string): string {
    return houseNumber ? `${streetName} ${houseNumber}` : streetName
}
